<template>
	<v-autocomplete
		:label="$attrs.label || $t('facePerson')"
		:items="FacePersons"
		:loading="LoadingPersons"
		item-text="Name"
		item-value="FacePersonId"
		v-bind="$attrs"
		v-bind:value="value"
		v-on="$listeners"
		@input="$emit('input', value)"
		:search-input.sync="search"
		clearable
	></v-autocomplete>
</template>
<script>
import CrudClient from "@/services/CrudClient/";
import { mapActions } from "vuex";

export default {
	data() {
		return {
			LoadingPersons: false,
			FacePersons: [],
			search: null,
			timeoutHandler: null,

			requestNo: 0,
		};
	},
	props: {
		value: { type: Number, default: null },
		// addEmptyItem: { type: Boolean, required: false, default: false },
	},
	created() {
		this.SgpFacePersonsService = new CrudClient("Face/Person");
	},
	watch: {
		async search(val) {
			this.$log.debug("Watch search: " + val);
			if (val && val !== this.value && val.length > 0) {
				// wait for 300ms before calling LoadPersonList
				// if searchInput is called another time, cancel the initial call
				clearTimeout(this.timeoutHandler);

				this.timeoutHandler = setTimeout(async () => {
					await this.LoadFacePersons(val);
				}, 300);
			}
		},

		value: {
			immediate: true,
			handler: async function (newVal) {
				if (!newVal) return;
				// Programmatic value set
				if (!this.FacePersons.find((i) => i.FacePersonId === newVal)) {
					const res = await this.SgpFacePersonsService.GetSelectedFields(
						newVal,
						"Name, FacePersonId"
					);

					this.search = res.Name;
				}
			},
		},
	},
	async mounted() {
		// await this.LoadFacePersons();
	},
	methods: {
		...mapActions(["snackSuccess", "snackError"]),
		async LoadFacePersons(val) {
			try {
				this.LoadingPersons = true;

				if (this.controller) {
					this.controller.abort();
				}

				const currentRequestNo = ++this.requestNo;
				this.controller = new AbortController();
				const res = await this.SgpFacePersonsService.GetWithOptions("SearchPerson?searchInput=" + encodeURIComponent(val), { signal: this.controller.signal });
				//					signal: this.controller.signal

				if (!res) {
					// request aborted
					return;
				}
				if (this.requestNo === currentRequestNo) {
					this.FacePersons = res;
				}
			} catch (error) {
				this.$captureError(error);
				this.snackError({ Text: this.$t("common.error.cannotLoadData") });
			} finally {
				this.LoadingPersons = false;
			}
		},
	},
};
</script>
